import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'
import { ROUTES } from '@/constants'

export function NotFound() {
  return (
    <div className="flex min-h-[calc(100vh-8rem)] items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-6xl font-bold text-primary">404</h1>
        <h2 className="mb-4 text-2xl font-semibold">ページが見つかりません</h2>
        <p className="mb-8 text-muted-foreground">
          お探しのページは存在しないか、移動した可能性があります。
        </p>
        <Link
          to={ROUTES.HOME}
          className="inline-flex items-center gap-2 rounded-lg bg-primary px-6 py-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          <Home className="h-4 w-4" />
          ホームに戻る
        </Link>
      </div>
    </div>
  )
}
